let isPrd = ( document.domain === 'm.changyoyo.com'|| document.domain === 'test-m.changyoyo.com');
let imgUrl = '';
let stgNum = document.domain.slice(10, 11);

if (!isPrd) {

  // 根据不同的测试环境匹配不同环境的CDN地址
  if (document.domain.indexOf('stg') > -1) {
    !isNaN(stgNum) && (imgUrl = `https://img${stgNum}.ppppoints.com`)
  }
}

let server = {
  // 不要修改协议头
  baseUrl: isPrd ? 'https://m.changyoyo.com' : 'https://test-m-stg.ppppoints.com',
  cssUrl: isPrd ? 'https://css.changyoyo.com' : 'https://css.ppppoints.com',
  jsUrl: isPrd ? 'https://js.changyoyo.com' : 'https://js.ppppoints.com',
  imgUrl: isPrd ? 'https://image.changyoyo.com' : imgUrl
}

export {
  server
}
